import { useNovel } from '@/context/novel-context';
import { EntitySummary } from '@/lib/types';
import { useMemo } from 'react';
import { toTimestamp } from '@/lib/date-utils';

/**
 * Hook to fetch all characters for a novel.
 * Uses novel metadata (summaries) which are novel-size agnostic.
 */
export function useCharacters() {
  const { novel, isLoading, error } = useNovel();

  const characters = useMemo(() => {
    const summaryMap = novel.summaries.characters;
    return Object.values(summaryMap)
      .sort((a, b) => {
        const dateA = toTimestamp(a.updatedAt);
        const dateB = toTimestamp(b.updatedAt);
        return dateB - dateA;
      });
  }, [novel]);

  return {
    characters,
    isLoading,
    error,
  };
}
